

import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './Commonlibs/store';
import Navbar from './Commonlibs/Navbar';
import Login from './Authuntication/Login';
import Register from './Authuntication/Register';
import ForgotPassword from './Authuntication/ForgotPassword';
import ChangePassword from './Authuntication/ChangePassword';
import Main from './Buyer/components/main';
import PropertySearch from './Buyer/components/Property/PropertySearch';
import PropertyView from './Buyer/components/Property/PropertyView';
import TalkView from './Buyer/components/Property/TalkView'; // Import TalkView
import Loader from './Loader/Loader';
import SellerProperties from './Seller/SellerProperties';
import Footer from './Commonlibs/Footer';
import ProfileContent from './Buyer/components/Profile/ProfileContent';
import ProfilePropEdit from './Buyer/components/Profile/ProfilePropEdit';
import ProfilePropLiked from './Buyer/components/Profile/ProfilePropLiked';
import ProfilePropViewed from './Buyer/components/Profile/ProfilePropViewed';
import ProfileViewMain from './Buyer/components/Profile/ProfileViewMain';
import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import Buyplans from './Seller/Buyplans';
import AddNewProperty from './Seller/AddNewProperty';
import PropertyDetails from './Seller/PropertyDetails';
// import PropertyCommercial from './Seller/PropertyCommercial';
import PriceDetails from './Seller/PriceDetails';
import RentDetails from './Seller/RentDetails';
import PropertySeeAll from './Seller/PropertySeeAll';
import RecommendedView from './Buyer/components/Home/ResidentialView';
import FeaturedView from './Buyer/components/Home/FeaturedView'; 
import NewlyView from './Buyer/components/Home/NewlyView';
import EditProperties from './Seller/EditProperties';
import ProfileSearchMain from './Buyer/components/Profile/ProfileSearchMain';
import ResidentialView from './Buyer/components/Home/ResidentialView';
import Amenities from './Seller/Amenities';
import PostAccess from './Seller/PostAccess';
// Create MUI theme with Outfit
const theme = createTheme({
  typography: {
    fontFamily: 'Outfit, sans-serif',
  },
  palette: {
    primary: {
      main: '#1976d2',
    },
  },
});
 
const AppContent = () => {
  const location = useLocation();
  const hideNavbarPaths = ['/login', '/register','/forgot-password'];
  const shouldShowNavbar = !hideNavbarPaths.includes(location.pathname);
  const shouldShowFooter = !hideNavbarPaths.includes(location.pathname);
 
  return (
    <>
      {shouldShowNavbar && <Navbar />}
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="/property" element={<PropertySearch />} />
        {/* <Route path="/view" element={<PropertyView />} /> */}
        <Route path="/view/:propertyId" element={<TalkView />} /> {/* Add route with ID parameter */}
        <Route path="/sell-properties" element={<SellerProperties />} />
        <Route path="/sell-properties/edit/:propertyId" element={<SellerProperties />} />
        <Route path="/sell-properties/inbox" element={<SellerProperties />} />
        <Route path="/sell-properties/transactions" element={<SellerProperties />} />
        <Route path="/sell-properties/seeAll" element={<SellerProperties />} />
        <Route path="/residential-view" element={<ResidentialView />} />
        <Route path="/featured-view" element={<FeaturedView />} />
        <Route path="/newly-view" element={<NewlyView />} />
        <Route path="/buy-plans" element={<Buyplans />} />
        <Route path="/add-new-property" element={<AddNewProperty />} />
        <Route path="/property-details" element={<PropertyDetails />} />
        {/* <Route path="/property-commercial" element={<PropertyCommercial />} /> */}
        <Route path="/price-details" element={<PriceDetails />} />
        <Route path="/amenities" element={<Amenities />} />
        <Route path="/rent-details" element={<RentDetails />} />
        <Route path="/profile" element={<ProfileContent />} />
        <Route path="/profile/view-main" element={<ProfileViewMain />} />
        <Route path="/profile/inbox" element={<ProfilePropViewed />} />
        <Route path="/profile/wishlist" element={<ProfilePropLiked />} />
        <Route path="/profile/recent-searches" element={<ProfileSearchMain />} />
        <Route path="/profile/edit" element={<ProfilePropEdit />} />
        <Route path="/price-details" element={<PriceDetails />} />
        <Route path="/rent-details" element={<RentDetails />} />
        <Route path="/sell-properties/edit/:propertyId" element={<EditProperties />} />
      </Routes>
      {shouldShowFooter && <Footer />}
    </>
  );
};
 
const App = () => {
  return (
    <Provider store={store}>
      <PersistGate loading={<Loader />} persistor={persistor}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Router>
            <AppContent />
          </Router>
        </ThemeProvider>
      </PersistGate>
    </Provider>
  );
};
 
export default App;








// import React, { useState } from 'react';
// import { BrowserRouter as Router, Routes, Route, useLocation, useNavigate } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
// import { store, persistor } from './Commonlibs/store';
// import Navbar from './Commonlibs/Navbar';
// import Login from './Authuntication/Login';
// import Register from './Authuntication/Register';
// import ForgotPassword from './Authuntication/ForgotPassword';
// import ChangePassword from './Authuntication/ChangePassword';
// import Main from './Buyer/components/main';
// import PropertySearch from './Buyer/components/Property/PropertySearch';
// import PropertyView from './Buyer/components/Property/PropertyView';
// import TalkView from './Buyer/components/Property/TalkView'; // Import TalkView
// import Loader from './Loader/Loader';
// import SellerProperties from './Seller/SellerProperties';
// import Footer from './Commonlibs/Footer';
// import ProfileContent from './Buyer/components/Profile/ProfileContent';
// import ProfilePropEdit from './Buyer/components/Profile/ProfilePropEdit';
// import ProfilePropLiked from './Buyer/components/Profile/ProfilePropLiked';
// import ProfilePropViewed from './Buyer/components/Profile/ProfilePropViewed';
// import ProfileViewMain from './Buyer/components/Profile/ProfileViewMain';
// import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
// import Buyplans from './Seller/Buyplans';
// import AddNewProperty from './Seller/AddNewProperty';
// import PropertyDetails from './Seller/PropertyDetails';
// // import PropertyCommercial from './Seller/PropertyCommercial';
// import PriceDetails from './Seller/PriceDetails';
// import RentDetails from './Seller/RentDetails';
// import PropertySeeAll from './Seller/PropertySeeAll';
// import RecommendedView from './Buyer/components/Home/ResidentialView';
// import FeaturedView from './Buyer/components/Home/FeaturedView'; 
// import NewlyView from './Buyer/components/Home/NewlyView';
// import EditProperties from './Seller/EditProperties';
// import ProfileSearchMain from './Buyer/components/Profile/ProfileSearchMain';
// import ResidentialView from './Buyer/components/Home/ResidentialView';
// // Create MUI theme with Outfit
// const theme = createTheme({
//   typography: {
//     fontFamily: 'Outfit, sans-serif',
//   },
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//   },
// });
 
// const AppContent = () => {
//   const location = useLocation();
//   const hideNavbarPaths = ['/login', '/register','/forgot-password'];
//   const shouldShowNavbar = !hideNavbarPaths.includes(location.pathname);
//   const shouldShowFooter = !hideNavbarPaths.includes(location.pathname);
 
//   return (
//     <>
//       {shouldShowNavbar && <Navbar />}
//       <Routes>
//         <Route path="/" element={<Main />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/forgot-password" element={<ForgotPassword />} />
//         <Route path="change-password" element={<ChangePassword />} />
//         <Route path="/property" element={<PropertySearch />} />
//         {/* <Route path="/view" element={<PropertyView />} /> */}
//         <Route path="/view/:propertyId" element={<TalkView />} /> {/* Add route with ID parameter */}
//         <Route path="/sell-properties" element={<SellerProperties />} />
//         <Route path="/sell-properties/edit/:propertyId" element={<SellerProperties />} />
//         <Route path="/sell-properties/inbox" element={<SellerProperties />} />
//         <Route path="/sell-properties/transactions" element={<SellerProperties />} />
//         <Route path="/sell-properties/seeAll" element={<SellerProperties />} />
//         <Route path="/residential-view" element={<ResidentialView />} />
//         <Route path="/featured-view" element={<FeaturedView />} />
//         <Route path="/newly-view" element={<NewlyView />} />
//         <Route path="/buy-plans" element={<Buyplans />} />
//         <Route path="/add-new-property" element={<AddNewProperty />} />
//         <Route path="/property-details" element={<PropertyDetails />} />
//         {/* <Route path="/property-commercial" element={<PropertyCommercial />} /> */}
//         <Route path="/price-details" element={<PriceDetails />} />
//         <Route path="/rent-details" element={<RentDetails />} />
//         <Route path="/profile" element={<ProfileContent />} />
//         <Route path="/profile/view-main" element={<ProfileViewMain />} />
//         <Route path="/profile/inbox" element={<ProfilePropViewed />} />
//         <Route path="/profile/wishlist" element={<ProfilePropLiked />} />
//         <Route path="/profile/recent-searches" element={<ProfileSearchMain />} />
//         <Route path="/profile/edit" element={<ProfilePropEdit />} />
//         <Route path="/price-details" element={<PriceDetails />} />
//         <Route path="/rent-details" element={<RentDetails />} />
//         <Route path="/sell-properties/edit/:propertyId" element={<EditProperties />} />
//       </Routes>
//       {shouldShowFooter && <Footer />}
//     </>
//   );
// };
 
// const App = () => {
//   return (
//     <Provider store={store}>
//       <PersistGate loading={<Loader />} persistor={persistor}>
//         <ThemeProvider theme={theme}>
//           <CssBaseline />
//           <Router>
//             <AppContent />
//           </Router>
//         </ThemeProvider>
//       </PersistGate>
//     </Provider>
//   );
// };
 
// export default App;





// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { PersistGate } from 'redux-persist/integration/react';
// import { store, persistor } from './Commonlibs/store';
// import Navbar from './Commonlibs/Navbar';
// import Login from './Authuntication/Login';
// import Register from './Authuntication/Register';
// import ForgotPassword from './Authuntication/ForgotPassword';
// import ChangePassword from './Authuntication/ChangePassword';
// import Main from './Buyer/components/main';
// import PropertySearch from './Buyer/components/Property/PropertySearch';
// import PropertyView from './Buyer/components/Property/PropertyView';
// import TalkView from './Buyer/components/Property/TalkView';
// import Loader from './Loader/Loader';
// import SellerProperties from './Seller/SellerProperties';
// import Footer from './Commonlibs/Footer';
// import ProfileContent from './Buyer/components/Profile/ProfileContent';
// import ProfilePropEdit from './Buyer/components/Profile/ProfilePropEdit';
// import ProfilePropLiked from './Buyer/components/Profile/ProfilePropLiked';
// import ProfilePropViewed from './Buyer/components/Profile/ProfilePropViewed';
// import ProfileViewMain from './Buyer/components/Profile/ProfileViewMain';
// import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
// import Buyplans from './Seller/Buyplans';
// import AddNewProperty from './Seller/AddNewProperty';
// import PropertyDetails from './Seller/PropertyDetails';
// import PriceDetails from './Seller/PriceDetails';
// import RentDetails from './Seller/RentDetails';
// import PropertySeeAll from './Seller/PropertySeeAll';
// import RecommendedView from './Buyer/components/Home/ResidentialView';
// import FeaturedView from './Buyer/components/Home/FeaturedView';
// import NewlyView from './Buyer/components/Home/NewlyView';
// import EditProperties from './Seller/EditProperties';
// import ProfileSearchMain from './Buyer/components/Profile/ProfileSearchMain';
// import ResidentialView from './Buyer/components/Home/ResidentialView';
 
// // Import Global Ad Component
// import GlobalAd from './Buyer/components/Ads/GlobalAd';
 
// // Create MUI theme
// const theme = createTheme({
//   typography: {
//     fontFamily: 'Outfit, sans-serif',
//   },
//   palette: {
//     primary: {
//       main: '#1976d2',
//     },
//   },
// });
 
// const AppContent = () => {
//   const location = useLocation();
//   const hideNavbarPaths = ['/login', '/register', '/forgot-password'];
//   const shouldShowNavbar = !hideNavbarPaths.includes(location.pathname);
//   const shouldShowFooter = !hideNavbarPaths.includes(location.pathname);
 
//   return (
//     <>
//       {/* Global Ad - Shows on Top of Everything */}
//     <GlobalAd position="top-right" />
     
//       {shouldShowNavbar && <Navbar />}
     
//       <Routes>
//         <Route path="/" element={<Main />} />
//         <Route path="/login" element={<Login />} />
//         <Route path="/register" element={<Register />} />
//         <Route path="/forgot-password" element={<ForgotPassword />} />
//         <Route path="change-password" element={<ChangePassword />} />
//         <Route path="/property" element={<PropertySearch />} />
//         <Route path="/view/:propertyId" element={<TalkView />} />
//         <Route path="/sell-properties" element={<SellerProperties />} />
//         <Route path="/sell-properties/edit/:propertyId" element={<SellerProperties />} />
//         <Route path="/sell-properties/inbox" element={<SellerProperties />} />
//         <Route path="/sell-properties/transactions" element={<SellerProperties />} />
//         <Route path="/sell-properties/seeAll" element={<SellerProperties />} />
//         <Route path="/residential-view" element={<ResidentialView />} />
//         <Route path="/featured-view" element={<FeaturedView />} />
//         <Route path="/newly-view" element={<NewlyView />} />
//         <Route path="/buy-plans" element={<Buyplans />} />
//         <Route path="/add-new-property" element={<AddNewProperty />} />
//         <Route path="/property-details" element={<PropertyDetails />} />
//         <Route path="/price-details" element={<PriceDetails />} />
//         <Route path="/rent-details" element={<RentDetails />} />
//         <Route path="/profile" element={<ProfileContent />} />
//         <Route path="/profile/view-main" element={<ProfileViewMain />} />
//         <Route path="/profile/inbox" element={<ProfilePropViewed />} />
//         <Route path="/profile/wishlist" element={<ProfilePropLiked />} />
//         <Route path="/profile/recent-searches" element={<ProfileSearchMain />} />
//         <Route path="/profile/edit" element={<ProfilePropEdit />} />
//         <Route path="/sell-properties/edit/:propertyId" element={<EditProperties />} />
//       </Routes>
 
//       {shouldShowFooter && <Footer />}
//     </>
//   );
// };
 
// const App = () => {
//   return (
//     <Provider store={store}>
//       <PersistGate loading={<Loader />} persistor={persistor}>
//         <ThemeProvider theme={theme}>
//           <CssBaseline />
//           <Router>
//             <AppContent />
//           </Router>
//         </ThemeProvider>
//       </PersistGate>
//     </Provider>
//   );
// };
 
// export default App;